import "./Services.scss";

export default function Services({ data }) {
  return (
    <section id="services" className="section">
      <div className="section-header">
        <div className="header-name">Services</div>
        <div className="header-line">What We Provide You?</div>
        <div className="line">
          <div className="bold-line"></div>
        </div>
      </div>
      <div className="services-content section-content">
        <div className="services-card card-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            viewBox="0 0 69.016 64.973"
          >
            <path
              className="a"
              d="M614.281,2598.986a2.03,2.03,0,0,1,0-4.061h6.631l1.348-4.061h24.48l1.348,4.061h6.631a2.03,2.03,0,0,1,0,4.061Zm-8.222-12.182a6.086,6.086,0,0,1-6.066-6.091v-2.03h69.016v2.03a6.2,6.2,0,0,1-6.2,6.091Zm62.949-12.181H656.741v-6.091a2.028,2.028,0,0,0-2.021-2.03H651.6a18.2,18.2,0,0,0-.719-1.74l2.21-2.22a2.04,2.04,0,0,0,0-2.871l-5.719-5.742a2.015,2.015,0,0,0-2.859,0l-2.211,2.22a18.518,18.518,0,0,0-1.732-.724v-3.136a2.029,2.029,0,0,0-2.022-2.03h-8.087a2.028,2.028,0,0,0-2.022,2.03v3.136a18.5,18.5,0,0,0-1.732.724l-2.211-2.22a2.013,2.013,0,0,0-2.859,0l-5.719,5.742a2.04,2.04,0,0,0,0,2.871l2.21,2.22a18.325,18.325,0,0,0-.719,1.74h-3.124a2.029,2.029,0,0,0-2.022,2.03v6.091H599.992V2540.1a6.085,6.085,0,0,1,6.066-6.09h56.749a6.219,6.219,0,0,1,4.355,1.785,5.982,5.982,0,0,1,1.846,4.3v34.518h0ZM648.65,2548.23a6.07,6.07,0,1,0,6.07-6.09A6.087,6.087,0,0,0,648.65,2548.23Zm-4.307,26.391a10.113,10.113,0,1,0-19.687,0H616.3v-4.061H618.9a2.024,2.024,0,0,0,1.958-1.523,14.019,14.019,0,0,1,1.5-3.619,2.039,2.039,0,0,0-.311-2.467l-1.84-1.848,2.859-2.871,1.84,1.848a2.008,2.008,0,0,0,2.459.312,13.861,13.861,0,0,1,3.6-1.5,2.031,2.031,0,0,0,1.516-1.968v-2.6h4.044v2.6a2.032,2.032,0,0,0,1.516,1.968,13.854,13.854,0,0,1,3.6,1.5,2.007,2.007,0,0,0,2.459-.312l1.84-1.848,2.859,2.871-1.839,1.848a2.039,2.039,0,0,0-.311,2.467,13.984,13.984,0,0,1,1.5,3.619,2.026,2.026,0,0,0,1.959,1.523H652.7v4.061Zm-15.517,0a6.067,6.067,0,1,1,11.347,0Z"
              transform="translate(-599.992 -2534.013)"
            />
          </svg>
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-heading">
                {servicesData.services_headings.heading1}
              </div>
            );
          })}
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-info">
                {servicesData.services_details.detail1}
              </div>
            );
          })}
        </div>
        <div className="services-card card-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            viewBox="0 0 72.005 65"
          >
            <path
              className="a"
              d="M1027.482,2597.817l-26-11.228c-2.222-.96-3.5-2.452-3.5-4.089s1.274-3.128,3.5-4.089l4.126-1.782,19.9,8.6a23.472,23.472,0,0,0,16.961,0l19.9-8.595,4.127,1.782c2.222.96,3.5,2.451,3.5,4.089s-1.274,3.128-3.5,4.089l-26,11.228a18.5,18.5,0,0,1-13.016,0Zm0-16-26-11.228c-2.222-.96-3.5-2.45-3.5-4.089s1.274-3.128,3.5-4.089l4.127-1.782,19.9,8.6a23.44,23.44,0,0,0,16.96,0l19.9-8.6,4.127,1.782c2.221.96,3.5,2.45,3.5,4.089s-1.274,3.128-3.5,4.089l-26,11.228a18.5,18.5,0,0,1-13.016,0Zm0-16-26-11.228c-2.222-.96-3.5-2.45-3.5-4.088s1.274-3.129,3.5-4.09l26-11.228a18.461,18.461,0,0,1,13.017,0l26,11.228c2.222.96,3.5,2.451,3.5,4.09s-1.275,3.127-3.5,4.088l-26,11.228a18.459,18.459,0,0,1-13.016,0Z"
              transform="translate(-997.988 -2533.999)"
            />
          </svg>
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-heading">
                {servicesData.services_headings.heading2}
              </div>
            );
          })}
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-info">
                {servicesData.services_details.detail2}
              </div>
            );
          })}
        </div>
        <div className="services-card card-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            viewBox="0 0 78.997 65"
          >
            <path
              className="a"
              d="M1471.684,2599h-74.368a2.247,2.247,0,0,1-2.315-2.167v-41.167h79v41.167A2.247,2.247,0,0,1,1471.684,2599Zm-23.3-28.166a2.377,2.377,0,0,0-1.636.635,2.068,2.068,0,0,0,0,3.063l7.621,7.134-7.621,7.136a2.067,2.067,0,0,0,0,3.063,2.425,2.425,0,0,0,3.272,0l9.257-8.666a2.069,2.069,0,0,0,0-3.064l-9.257-8.666A2.377,2.377,0,0,0,1448.386,2570.833Zm-9.252,0a2.339,2.339,0,0,0-2.076,1.2l-9.257,17.333a2.032,2.032,0,0,0-.14,1.614,2.195,2.195,0,0,0,1.175,1.294,2.439,2.439,0,0,0,1.033.229,2.329,2.329,0,0,0,2.073-1.2l9.257-17.334a2.029,2.029,0,0,0,.14-1.614,2.191,2.191,0,0,0-1.175-1.294A2.449,2.449,0,0,0,1439.134,2570.835Zm-18.521,0a2.38,2.38,0,0,0-1.636.635l-9.257,8.666a2.071,2.071,0,0,0,0,3.064l9.257,8.666a2.426,2.426,0,0,0,3.273,0,2.069,2.069,0,0,0,0-3.063l-7.621-7.136,7.621-7.134a2.07,2.07,0,0,0,0-3.063A2.381,2.381,0,0,0,1420.613,2570.833Zm-13.885-8.667a2.171,2.171,0,1,0,0,4.333h55.544a2.171,2.171,0,1,0,0-4.333ZM1474,2551.333h-79v-15.167a2.247,2.247,0,0,1,2.315-2.167h74.368a2.247,2.247,0,0,1,2.315,2.167v15.166ZM1462.27,2540.5a2.174,2.174,0,1,0,2.31,2.17A2.245,2.245,0,0,0,1462.27,2540.5Zm-9.259,0a2.174,2.174,0,1,0,2.309,2.17A2.246,2.246,0,0,0,1453.01,2540.5Zm-9.25,0a2.174,2.174,0,1,0,2.309,2.17A2.246,2.246,0,0,0,1443.76,2540.5Zm-37.032,0a2.171,2.171,0,1,0,0,4.333h23.144a2.171,2.171,0,1,0,0-4.333Z"
              transform="translate(-1395.001 -2533.999)"
            />
          </svg>
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-heading">
                {servicesData.services_headings.heading3}
              </div>
            );
          })}
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-info">
                {servicesData.services_details.detail3}
              </div>
            );
          })}
        </div>
        <div className="services-card card-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            viewBox="0 0 72.977 64.991"
          >
            <path
              className="a"
              d="M660.989,2999H588.011v-46.615h42.336l15.233-18.375h15.408V2999Zm-26.882-18.669h0l3.489,6.324h4.891l-5.935-10.758,5.935-10.758H637.6l-3.49,6.325-3.49-6.325h-4.891l5.936,10.758-5.936,10.758h4.891l3.489-6.324Zm-28.479-15.118v13.411a7.911,7.911,0,1,0,15.821,0v-13.411h-4.276v13.411a3.635,3.635,0,1,1-7.269,0v-13.411Zm22.718-17.132H588.011v-14.072h52l-11.666,14.072h0Zm-13.066-9.271v4.331h4.28v-4.331Zm-9.19,0v4.331h4.28v-4.331Zm-9.19,0v4.331h4.28v-4.331Z"
              transform="translate(-588.011 -2934.009)"
            />
          </svg>
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-heading">
                {servicesData.services_headings.heading4}
              </div>
            );
          })}
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-info">
                {servicesData.services_details.detail4}
              </div>
            );
          })}
        </div>
        <div className="services-card card-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            viewBox="0 0 64.99 64.99"
          >
            <path
              className="a"
              d="M1039.946,2998.994h-33.616v-1.12a3.365,3.365,0,0,1,3.362-3.362h26.892a3.366,3.366,0,0,1,3.362,3.362v1.119Zm-8.277-6.724h-17.061l1.494-4.482h14.073l1.494,4.481Zm18.362-6.722H996.246a2.244,2.244,0,0,1-2.241-2.242v-40.338a2.244,2.244,0,0,1,2.241-2.241H1020.9v4.482h-20.169a2.244,2.244,0,0,0-2.241,2.241v29.133a2.244,2.244,0,0,0,2.241,2.241h44.82a2.244,2.244,0,0,0,2.242-2.241v-8.963h4.482v15.686A2.244,2.244,0,0,1,1050.031,2985.549Zm-11.2-4.479v2.24h2.24v-2.24Zm-4.489,0v2.24h2.239v-2.24Zm-4.48,0v2.24h2.24v-2.24Zm15.688-4.486h-44.82v-29.133H1020.9v16.807a3.366,3.366,0,0,0,3.362,3.362h21.289v8.962Zm-4.478-4.484v2.24h2.24v-2.24Zm-38.1,0v2.24h35.86v-2.24Zm2.24-11.2v6.724h13.446v-11.206h-4.482v-6.722h-11.205v11.2Zm52.664,4.482h-33.616a1.122,1.122,0,0,1-1.121-1.121v-5.6h35.857v5.6A1.122,1.122,0,0,1,1057.874,2965.379Zm-30.254-4.479v2.24h26.89v-2.24Zm-11.2,4.479h-8.964V2960.9h6.723v-2.241h2.241v6.722Zm-4.485-6.729h-6.72v-6.72h6.72v6.719Zm47.065-2.236h-35.857v-21.29a1.122,1.122,0,0,1,1.121-1.12h33.616a1.122,1.122,0,0,1,1.12,1.12v21.289Zm-24.652-19.74h0v17.072l17.073-8.537-17.073-8.535Z"
              transform="translate(-994.005 -2934.005)"
            />
          </svg>
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-heading">
                {servicesData.services_headings.heading5}
              </div>
            );
          })}
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-info">
                {servicesData.services_details.detail5}
              </div>
            );
          })}
        </div>
        <div className="services-card card-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            viewBox="0 0 64.999 65"
          >
            <path
              className="a"
              d="M1403.9,2999a1.9,1.9,0,1,1,0-3.809h2.031v-21.2a1.9,1.9,0,0,1,1.9-1.9h7.618a1.9,1.9,0,0,1,1.9,1.9v21.2h3.809v-13.584a1.9,1.9,0,0,1,1.9-1.9h7.617a1.9,1.9,0,0,1,1.9,1.9v13.584h3.808v-28.817a1.9,1.9,0,0,1,1.9-1.9h7.618a1.9,1.9,0,0,1,1.9,1.9v28.817h3.809v-40.243a1.9,1.9,0,0,1,1.9-1.9h7.618a1.9,1.9,0,0,1,1.9,1.9v40.243h2.031a1.9,1.9,0,0,1,0,3.809Zm17.266-32.626a5.677,5.677,0,0,1,.069-.693l-5.637-2.818a5.7,5.7,0,1,1,1.759-4.107,5.493,5.493,0,0,1-.07.692l5.637,2.818a5.612,5.612,0,0,1,6.4-1.033l7.647-7.646a5.65,5.65,0,0,1-.573-2.448,5.706,5.706,0,0,1,8.876-4.752l6.644-4.982a5.63,5.63,0,0,1-.285-1.692,5.724,5.724,0,1,1,2.551,4.752l-6.644,4.981a5.642,5.642,0,0,1,.285,1.692,5.719,5.719,0,0,1-5.713,5.713,5.636,5.636,0,0,1-2.447-.573l-7.647,7.647a5.651,5.651,0,0,1,.573,2.448,5.713,5.713,0,0,1-11.425,0Z"
              transform="translate(-1402 -2933.999)"
            />
          </svg>
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-heading">
                {servicesData.services_headings.heading6}
              </div>
            );
          })}
          {data.ServicesData.map((servicesData) => {
            return (
              <div className="card-info">
                {servicesData.services_details.detail6}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
